module.exports = __webpack_public_path__ + "static/media/enisa.514ce0da.png";